import { NotificationType } from '@/api/models/notifications/lib/notifications.types'
import {
  checkboxItemAll,
  checkboxItemUnread
} from '@/components/shared/checkbox/lib/constants'
import { CheckboxGroupOption } from '@/components/shared/checkbox/ui/AppCheckboxGroup.types'

import { NotificationTypeValue } from './NotificationTypesFilter.types'

export const notificationTypeOptionsMap: CheckboxGroupOption<
  NotificationTypeValue | NotificationTypeValue[]
>[] = [
  {
    value: checkboxItemAll,
    label: 'Все'
  },
  {
    value: checkboxItemUnread,
    label: 'Непрочитанные'
  },
  {
    value: NotificationType.Passes,
    label: 'Пропуска'
  },
  {
    value: NotificationType.Requests,
    label: 'Обращения'
  },
  {
    value: [
      NotificationType.Invoices,
      NotificationType.InvoicesReminder,
      NotificationType.InvoicesDebt
    ],
    label: 'Счета'
  },
  {
    value: NotificationType.Comments,
    label: 'Чат'
  },
  {
    value: NotificationType.Counters,
    label: 'Приборы учёта'
  },
  {
    value: NotificationType.News,
    label: 'Новости'
  },
  {
    value: NotificationType.Proposals,
    label: 'Предложения'
  }
]
